import { formatDate } from '@angular/common';
import { Component, Input } from '@angular/core';
import { EMPTY, switchMap } from 'rxjs';
import { DialogService } from '@app/core/services';
import { BankService } from '@app/shared/services/bank.service';

@Component({
    selector: 'ajs-cancel-print-checks-session-button',
    templateUrl: './ajs-cancel-print-checks-session.component.html',
    standalone: true,
})
export class AjsCancelPrintChecksSessionButtonComponent {
	@Input() bankId: number;
	hcmSessionId: string;
	fmSessionId: number;
	hasLogs: boolean;
	constructor(private readonly dialogService: DialogService, private readonly bankService: BankService) {}
	cancelPrintChecksSession(): void {
		this.bankService
			.getCheckProcessingInfo(this.bankId)
			.pipe(
				switchMap((checkProcessingInfo) => {
					let checkProcessingInfoMessage = '';
					const noPrintingMessage = 'No active printing sessions found for this bank.';
					if (checkProcessingInfo.isValid) {
						const hcmData = checkProcessingInfo.data.HCMCheckProcessingSession;
						const fmData = checkProcessingInfo.data.FMCheckProcessingSession;

						if (hcmData != null) {
							this.hcmSessionId = hcmData.HCMProcessGuid;
							checkProcessingInfoMessage += `Human Capital Management session to be cleared was started by ${
								hcmData.UserName
							} at ${formatDate(hcmData.StartDate, 'yyyy-MM-dd hh:mm a', 'en-US')} for Bank Code: ${
								checkProcessingInfo.data.BankCode
							} Are you sure you want to clear this session?<br>`;
						}

						if (fmData != null) {
							this.fmSessionId = fmData.FMProcessId;
							checkProcessingInfoMessage += `<br>Fund Management session to be cleared was started by ${
								fmData.UserName
							} at ${formatDate(fmData.StartDate, 'yyyy-MM-dd hh:mm a', 'en-US')} for Bank Code: ${
								checkProcessingInfo.data.BankCode
							} Are you sure you want to clear this session?`;
						}

						if (fmData != null || hcmData != null) {
							this.hasLogs = true;
							return this.dialogService.open({
								title: 'Warning',
								message: checkProcessingInfoMessage,
								showCancel: true,
							});
						}

						this.hasLogs = false;
						return this.dialogService.open({
							title: 'Alert',
							message: noPrintingMessage,
							showCancel: false,
						});
					}

					return EMPTY;
				}),
				switchMap((dialogOneResult) => {
					if (dialogOneResult && !this.hasLogs) {
						return EMPTY;
					}

					if (dialogOneResult) {
						return this.dialogService.open({
							title: 'Please confirm the following before proceeding',
							message: `<p>Confirm the last checks printed</p><ul>
							<li>Confirm transaction history of cash account in account in manage accounts</li>
							<li>Match checks showing on cash account transaction history against the check register </li>
							<li>In Bank Setup within System Settings, confirm the next check number is correct</li>
							</ul>`,
							showCancel: true,
						});
					}

					this.fmSessionId = null;
					this.hcmSessionId = null;
					return EMPTY;
				}),
				switchMap((dialogTwoResult) => {
					if (!dialogTwoResult) {
						return EMPTY;
					}

					return this.dialogService.open({
						title: 'Warning',
						message: `Are you sure you want to proceed with clearing the checks being run status?`,
						showCancel: true,
					});
				}),
				switchMap((dialogThreeResult) => {
					if (!dialogThreeResult) {
						return EMPTY;
					}

					return this.bankService.cancelPrintChecksSession(this.bankId, this.hcmSessionId, this.fmSessionId);
				})
			)
			.subscribe((result) => {
				if (!result.data.isValid || !result.isValid) {
					this.dialogService.open({
						title: 'Error',
						message: result.data.errors.join('<br>'),
						showCancel: false,
					});

					return;
				}

				this.dialogService.open({
					title: 'Success',
					message: 'Check locks have been successfully cleared.',
					showCancel: false,
				});
			});
	}
}
